import {requestedTerminalMode} from 'hooks/terminalMode';
import {useKioskoStore} from '../useKioskoStore';

export const useKioskoConnectionStatus = () => {
  const isConnected = useKioskoStore(state => state.connection.isConnected);
  const hasCompletedInitialization = useKioskoStore(
    state => state.connection.hasCompletedInitialization,
  );

  const isAttempted = requestedTerminalMode === 'kiosko';

  return {isConnected, hasCompletedInitialization, isAttempted};
};
